export class ImageTransformStateModel {
  rotation: number = 0;
  positionX: number = 0;
  positionY: number = 0;
  maxWidth: number = 672;
  maxHeight: number = 426;
  initialMaxWidth: number = 672;
  initialMaxHeight: number = 426;
  originalAspectRatio: number = 1;
  displayMode: 'fill' | 'fit' = 'fill';
  
  // Gesture handling state
  isDragging: boolean = false;
  lastTouchX: number = 0;
  lastTouchY: number = 0;
  lastPinchScale: number = 1;
  
  // Internal gesture tracking
  initialMaxWidthForGesture: number = 672;
  initialMaxHeightForGesture: number = 426;
  cumulativeScale: number = 1.0; // Tracks cumulative scale from gesture start
  
  // Initial load state - prevents transitions during initial scaling
  isInitialLoad: boolean = false;

  // Active pinch-zoom state - prevents CSS transitions fighting the gesture
  isPinching: boolean = false;

  reset(): void {
    this.rotation = 0;
    this.positionX = 0;
    this.positionY = 0;
    this.maxWidth = 672;
    this.maxHeight = 426;
    this.initialMaxWidth = 672;
    this.initialMaxHeight = 426;
    this.originalAspectRatio = 1;
    this.displayMode = 'fill';
    this.isDragging = false;
    this.lastTouchX = 0;
    this.lastTouchY = 0;
    this.lastPinchScale = 1;
    this.initialMaxWidthForGesture = 672;
    this.initialMaxHeightForGesture = 426;
    this.cumulativeScale = 1.0;
    this.isInitialLoad = false;
    this.isPinching = false;
  }

  resetPosition(): void {
    this.positionX = 0;
    this.positionY = 0;
  }

  resetRotation(): void {
    this.rotation = 0;
  }

  resetDimensions(): void {
    this.maxWidth = this.initialMaxWidth;
    this.maxHeight = this.initialMaxHeight;
  }
}

